<template>
    <md-card class="wrapper">
      <md-card-header>
        <div class="md-title">
					<h1 v-if="edit">Edit</h1>
					<h1 v-else>Create</h1>
				</div>
      </md-card-header>
			<md-card-content>
				<div class="md-layout md-gutter">
					<div class="md-layout-item">
						<md-field>
							<label>id</label>
							<md-input readonly v-model="body.id"></md-input>
						</md-field>
						<md-field>
							<label>created_type</label>
							<md-input readonly v-model="body.created_type"></md-input>
						</md-field>
						<md-field v-if="is_model">
							<label>model_index</label>
							<md-input v-model="body.model_index" type="number"></md-input>
						</md-field>
						<!-- <md-field v-if="is_model">
							<label>ios_icon</label>
							<md-input v-model="body.ios_icon"></md-input>
						</md-field>
						<md-field v-if="is_model">
							<label>web_icon</label>
							<md-input v-model="body.web_icon"></md-input>
						</md-field> -->
					</div>
					<div class="md-layout-item">
						<md-field>
							<label>jp</label>
							<md-input v-model="body.jp"></md-input>
						</md-field>
						<md-field>
							<label>en</label>
							<md-input v-model="body.en"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item" v-if="is_model_or_popular">
						<md-field>
							<label>sepcial_keywords</label>
							<md-textarea v-model="body.sepcial_keywords"></md-textarea>
						</md-field>

						<md-field>
							<label>sepcial_domains</label>
							<md-textarea v-model="body.sepcial_domains"></md-textarea>
						</md-field>
					</div>
				</div>
			</md-card-content>
			<md-card-actions>
        <md-button @click="save">save</md-button>
      </md-card-actions>
		</md-card>
</template>

<script>

export default {
	name: 'DefaulTag',
	data() {
    return {
			body: {}
    };
	},
	computed: {
		edit: function () {
			return this.body.id ? true : false
		},
		selected_tag: function () {
			return this.$store.getters['default_tags/selected_tag']
		},
		is_model: function () {
			return this.$store.getters['default_tags/is_model']
		},
		is_model_or_popular: function () {
			return this.$store.getters['default_tags/is_model_or_popular']
		},
		current_created_type: function () {
			return this.$store.state.default_tags.current_created_type
		},
	},
	watch: {
		selected_tag: {
			immediate: true,
			handler(val) {
				this.body = val
			},
		},
		current_created_type: {
			immediate: true,
			handler(val) {
				this.body.created_type = val
			},
		}
	},
	methods: {
		save() {
			if (this.edit) {
				this.update()
			} else {
				this.new()
			}
		},
		update() {
			this.$store.dispatch('default_tags/update', this.body)
		},
		new() {
			this.$store.dispatch('default_tags/new', this.body)
			this.$store.commit('default_tags/set_selected', '')
			this.body.created_type = this.current_created_type
		},
	},
}
</script>
<style scoped>
.wrapper{
	/* margin-top: 100px; */
}
</style>
